import type { TLRichText } from "@tldraw/tlschema";

type Node = { type?: string; text?: string; content?: Node[] };
const BLOCKS = new Set([
  "paragraph",
  "heading",
  "listItem",
  "taskItem",
  "blockquote",
  "codeBlock",
]);

/** Plain text of a rich text document: text nodes, with line breaks between blocks. */
export function richTextPlainText(text: TLRichText | undefined): string {
  const out: string[] = [];
  const visit = (node: Node) => {
    if (node.type === "text" && node.text) out.push(node.text);
    else if (node.type === "hardBreak") out.push("\n");
    node.content?.forEach(visit);
    if (node.type && BLOCKS.has(node.type)) out.push("\n");
  };
  if (text) visit(text as Node);
  return out.join("").replace(/\n+$/, "");
}
